import request from '../../axios';

export const getValidationReport = async (
  loanGuid?: string,
): Promise<ValidationReportResponse> => {
  const response = await request.get<ValidationReportResponse>(
    '/api/v2/payment/farm-validation/report/loan-request/' + loanGuid,
  );

  return response.data;
};
